import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#F0F9FF]">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link
          to="/"
          data-testid="terms-back-link"
          className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-zinc-600 hover:text-black"
        >
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>

        <div className="mt-6">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">/ Legal</p>
          <h1 className="mt-2 font-heading font-black text-4xl sm:text-5xl tracking-tighter">
            Terms & Privacy.
          </h1>
          <p className="mt-3 text-zinc-600">
            Last updated: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
          </p>
        </div>

        <section data-testid="terms-section" className="mt-10 bg-white border-2 border-black p-6 sm:p-8 space-y-4">
          <h2 className="font-heading font-black text-2xl">Terms & Conditions</h2>
          <p className="text-sm text-zinc-700 leading-relaxed">
            By using Smart S Notes ("the Service"), you agree to these Terms. The Service converts your input
            (text, PDFs, URLs, YouTube links, audio, video, and images) into structured study notes powered by
            third-party AI models. You are responsible for the content you upload and must have the right to
            use it.
          </p>
          <ul className="list-disc pl-5 space-y-2 text-sm text-zinc-700">
            <li>You must be at least 13 years old to create an account.</li>
            <li>Do not upload content that is illegal, infringing, or violates a third party's rights.</li>
            <li>Free-tier limits, monthly quotas, and paid plan features are described on the Billing page.</li>
            <li>We may suspend accounts that abuse the Service or attempt to bypass quotas.</li>
            <li>The Service is provided "as is" without warranty. AI-generated notes may contain errors — always verify important information.</li>
          </ul>
        </section>

        <section data-testid="privacy-section" className="mt-6 bg-white border-2 border-black p-6 sm:p-8 space-y-4">
          <h2 className="font-heading font-black text-2xl">Privacy Policy</h2>
          <p className="text-sm text-zinc-700 leading-relaxed">
            We store your email, password (hashed), and the notes you generate so we can serve them back to you.
            Uploaded files and text are sent to AI providers (OpenAI, Google) for processing and are not sold to
            third parties.
          </p>
          <ul className="list-disc pl-5 space-y-2 text-sm text-zinc-700">
            <li>Your notes are private by default; only shared links are publicly viewable.</li>
            <li>Payments are processed by Razorpay — we do not store card details.</li>
            <li>You can request account deletion at any time by contacting support.</li>
          </ul>
        </section>

        <section data-testid="email-usage-section" className="mt-6 bg-white border-2 border-black p-6 sm:p-8 space-y-4">
          <h2 className="font-heading font-black text-2xl">Email Usage</h2>
          <p className="text-sm text-zinc-700 leading-relaxed">
            When you sign in with Google or create an account with email &amp; password, we collect your email
            address and, for Google sign-in, your basic profile (name and profile picture). We use this
            information strictly to:
          </p>
          <ul className="list-disc pl-5 space-y-2 text-sm text-zinc-700">
            <li>Identify your account and sign you in.</li>
            <li>Send you transactional emails (account confirmations, receipts, and password resets).</li>
            <li>Notify you about important changes to the Service or your subscription.</li>
          </ul>
          <p className="text-sm text-zinc-700 leading-relaxed">
            We <strong>do not sell, rent, or share your email</strong> with advertisers or third-party marketers.
            We do not send marketing newsletters unless you explicitly opt in. Our Google sign-in flow is
            provided by our authentication partner and requests only the minimum scopes needed
            (<span className="font-mono text-xs">email</span> and <span className="font-mono text-xs">profile</span>).
          </p>
        </section>

        <p className="mt-8 text-xs font-mono uppercase tracking-widest text-zinc-500">
          Questions? Reach us via the Contact link on the landing page.
        </p>
      </div>
    </div>
  );
}
